// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3rUJw","header":"MergedInvoice_header__2dGdy"};